import { CollapsibleContext } from "./chunk-P4FH6SY6.js";
import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/Collapsible/Collapsible.tsx
import { useMemo } from "react";
import clsx from "clsx";
import { Disclosure } from "@headlessui/react";
import { jsx } from "react/jsx-runtime";
var COLLAPSIBLE_CLASSNAME_MAP = {
  variant: {
    primary: "pd:collapsible--primary",
    secondary: "pd:collapsible--secondary"
  }
};
var Collapsible = _a => {
  var _b = _a,
    {
      id,
      children,
      isOpen,
      variant = "primary",
      className
    } = _b,
    rest = __objRest(_b, ["id", "children", "isOpen", "variant", "className"]);
  const context = useMemo(() => ({
    id,
    isOpen
  }), [id, isOpen]);
  return /* @__PURE__ */jsx(CollapsibleContext.Provider, {
    value: context,
    children: /* @__PURE__ */jsx(Disclosure, __spreadProps(__spreadValues({}, rest), {
      as: "div",
      id,
      className: _ref => {
        let {
          open
        } = _ref;
        return clsx("pd:collapsible", COLLAPSIBLE_CLASSNAME_MAP.variant[variant],
        // Only listen to internally managed state (open render prop) if isOpen is not defined.
        typeof isOpen === "undefined" && open && "pd:collapsible--open", typeof isOpen === "boolean" && isOpen && "pd:collapsible--open", className);
      },
      children
    }))
  });
};
var Collapsible_default = Collapsible;
export { COLLAPSIBLE_CLASSNAME_MAP, Collapsible_default };